import _regeneratorRuntime from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useEffect } from 'react';
import { ExpressCheckoutElement } from '@stripe/react-stripe-js';
import paymentMethodTypes from '../../../constants/paymentMethodTypeConstants.js';
import paymentStatus from '../../../constants/paymentStatusConstants.js';
import mapShippingRatesToStripe from '../../../utils/mapShippingRatesToStripe.js';
import { checkIsExpressCheckout, checkIsApplePayCheckout, checkIsApplePayExpressCheckout, checkIsGooglePayCheckout } from '../../../utils/paymentMethod.js';
import StubbedBillingActions$1 from '../../stubbed/stubbed-billing-address-selector/StubbedBillingActions.js';
import StubbedBillingActions from '../../stubbed/stubbed-shipping-address-selector/StubbedShippingActions.js';
import StubbedStatusSelector from '../../stubbed/stubbed-status-selector/StubbedStatusSelector.js';
import StubbedWrapper from '../../stubbed/stubbed-wrapper/StubbedWrapper.js';
var StripeExpressCheckoutElement = function StripeExpressCheckoutElement(_ref) {
  var amount = _ref.amount,
    billing_details = _ref.billingDetails,
    classNames = _ref.classNames,
    elements = _ref.elements,
    isStubbed = _ref.isStubbed,
    _ref$onReadyToRenderH = _ref.onReadyToRenderHandler,
    onReadyToRenderHandler = _ref$onReadyToRenderH === void 0 ? function () {} : _ref$onReadyToRenderH,
    _ref$onSubmitHandler = _ref.onSubmitHandler,
    onSubmitHandler = _ref$onSubmitHandler === void 0 ? function () {} : _ref$onSubmitHandler,
    paymentHandlers = _ref.paymentHandlers,
    paymentMethodType = _ref.paymentMethodType;
  var _useState = useState(paymentStatus.AUTHORISED),
    _useState2 = _slicedToArray(_useState, 2),
    stubbedStatus = _useState2[0],
    setStubbedStatus = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    shippingOptionRates = _useState4[0],
    setShippingOptionRates = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedShippingOptionIdentifier = _useState6[0],
    setSelectedShippingOptionIdentifier = _useState6[1];
  var isExpressCheckout = checkIsExpressCheckout(paymentMethodType);
  var onCancelHandler = function onCancelHandler(data) {
    console.log('debug: onCancelHandler', data);
  };
  var onConfirmHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var billingDetails, shippingAddress, mergedBillingDetails;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            billingDetails = event.billingDetails, shippingAddress = event.shippingAddress;
            if (billingDetails) {
              _context.next = 4;
              break;
            }
            console.warn('Missing billing details from Stripe event');
            return _context.abrupt("return");
          case 4:
            mergedBillingDetails = _objectSpread(_objectSpread({}, billingDetails), {}, {
              phone: (billingDetails === null || billingDetails === void 0 ? void 0 : billingDetails.phone) || (billing_details === null || billing_details === void 0 ? void 0 : billing_details.phone) || ''
            });
            onSubmitHandler({
              billingDetails: mergedBillingDetails,
              selectedShippingOptionIdentifier: selectedShippingOptionIdentifier,
              shippingAddress: shippingAddress,
              stubbedStatus: stubbedStatus
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onConfirmHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onEscapeHandler = function onEscapeHandler() {
    console.log('debug: onEscapeHandler');
  };
  var onReadyHandler = function onReadyHandler(event) {
    var _paymentHandlers$onRe;
    var availablePaymentMethods = event.availablePaymentMethods;
    var normalisedMethod = paymentMethodType === paymentMethodTypes.APPLE_PAY_EXPRESS ? paymentMethodTypes.APPLE_PAY : paymentMethodType;
    var isAvailable = isExpressCheckout ? !!(availablePaymentMethods !== null && availablePaymentMethods !== void 0 && availablePaymentMethods[normalisedMethod]) : false;
    onReadyToRenderHandler(isAvailable);
    paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onRe = paymentHandlers.onReady) === null || _paymentHandlers$onRe === void 0 || _paymentHandlers$onRe.call(paymentHandlers, isAvailable);
  };
  var onShippingAddressChangeHandler = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      var resolve, reject, shippingAddress, result, _result$shippingRates, shippingRates, shouldReject, stripeShippingRates;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            resolve = event.resolve, reject = event.reject, shippingAddress = event.address;
            if (!(paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.onShippingAddressChange)) {
              _context2.next = 7;
              break;
            }
            _context2.next = 4;
            return paymentHandlers.onShippingAddressChange({
              shippingAddress: shippingAddress
            });
          case 4:
            _context2.t0 = _context2.sent;
            _context2.next = 8;
            break;
          case 7:
            _context2.t0 = {
              shouldReject: true
            };
          case 8:
            result = _context2.t0;
            _result$shippingRates = result.shippingRates, shippingRates = _result$shippingRates === void 0 ? [] : _result$shippingRates, shouldReject = result.shouldReject;
            if (!shouldReject) {
              _context2.next = 13;
              break;
            }
            reject();
            return _context2.abrupt("return");
          case 13:
            stripeShippingRates = mapShippingRatesToStripe(shippingRates);
            setShippingOptionRates(stripeShippingRates);
            setSelectedShippingOptionIdentifier(stripeShippingRates[0].id);
            resolve({
              shippingRates: stripeShippingRates
            });
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onShippingAddressChangeHandler(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onShippingRateChangeHandler = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
      var resolve, shippingRate;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            resolve = event.resolve, shippingRate = event.shippingRate;
            setSelectedShippingOptionIdentifier(shippingRate.id);
            elements === null || elements === void 0 || elements.update({
              amount: amount + shippingRate.amount
            });
            resolve();
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onShippingRateChangeHandler(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (isStubbed) {
      var _paymentHandlers$onRe2;
      onReadyToRenderHandler(true);
      paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onRe2 = paymentHandlers.onReady) === null || _paymentHandlers$onRe2 === void 0 || _paymentHandlers$onRe2.call(paymentHandlers, true);
    }
  }, [isStubbed]);
  var isApplePayCheckout = checkIsApplePayCheckout(paymentMethodType);
  var isApplePayExpressCheckout = checkIsApplePayExpressCheckout(paymentMethodType);
  var isGooglePayCheckout = checkIsGooglePayCheckout(paymentMethodType);
  var expressCheckoutElementOptions = isApplePayExpressCheckout ? {
    allowedShippingCountries: ['GB', 'GG', 'IM', 'JE'],
    shippingAddressRequired: true,
    shippingRates: []
  } : {};
  return React.createElement("div", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.expressPaymentElement
  }, isStubbed ? React.createElement(React.Fragment, null, React.createElement(StubbedWrapper, null, React.createElement(StubbedStatusSelector, {
    stubbedStatus: stubbedStatus,
    onChange: setStubbedStatus
  }), React.createElement(StubbedBillingActions, {
    onShippingAddressChange: onShippingAddressChangeHandler,
    selectedShippingOptionIdentifier: selectedShippingOptionIdentifier,
    setSelectedShippingOptionIdentifier: setSelectedShippingOptionIdentifier,
    shippingRates: shippingOptionRates
  }), selectedShippingOptionIdentifier && React.createElement(StubbedBillingActions$1, {
    onConfirm: onConfirmHandler,
    paymentMethodType: paymentMethodType
  }))) : React.createElement(ExpressCheckoutElement, {
    onCancel: onCancelHandler,
    onConfirm: onConfirmHandler,
    onEscape: onEscapeHandler,
    onReady: onReadyHandler,
    onShippingAddressChange: onShippingAddressChangeHandler,
    onShippingRateChange: onShippingRateChangeHandler,
    options: _objectSpread({
      billingAddressRequired: true,
      buttonHeight: 40,
      emailRequired: true,
      paymentMethods: {
        applePay: isApplePayCheckout ? 'always' : 'never',
        googlePay: isGooglePayCheckout ? 'always' : 'never',
        link: 'never',
        paypal: 'never'
      },
      phoneNumberRequired: true
    }, expressCheckoutElementOptions)
  }));
};
export { StripeExpressCheckoutElement as default };